import type { TableConfig } from '@/types/table/table-config'
import type { TableData } from '@/types/table/table-data'
import type { TableHead } from '@/types/table/table-head'

export function createTableConfig<T>(
  heads: TableHead[],
  data: TableData<T>[],
  idFieldKey?: string
): TableConfig<T> {
  return { heads, data, idFieldKey }
}
